import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-520b2d66"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数据总览", -1));
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  style: {
    "max-height": "400px",
    "overflow-y": "scroll"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_DashboardInfoCard = _resolveComponent("DashboardInfoCard");
  const _component_el_col = _resolveComponent("el-col");
  const _component_IndexEmActivity = _resolveComponent("IndexEmActivity");
  const _component_IndexInfoActivity = _resolveComponent("IndexInfoActivity");
  const _component_IndexWarnActivity = _resolveComponent("IndexWarnActivity");
  const _component_VerticalBarChart = _resolveComponent("VerticalBarChart");
  const _component_LineChart = _resolveComponent("LineChart");
  const _component_ClockRecord = _resolveComponent("ClockRecord");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "dashboardContent",
    gutter: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_createVNode(_component_DashboardInfoCard, {
        title: "警情事件总数",
        total: $data.baseData.policeEventTotal,
        yesterday: $data.baseData.policeEventYesterday
      }, null, 8, ["total", "yesterday"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_createVNode(_component_DashboardInfoCard, {
        title: "上报事件总数",
        total: $data.baseData.reportEventTotal,
        yesterday: $data.baseData.reportEventYesterday
      }, null, 8, ["total", "yesterday"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 14
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_DashboardInfoCard, {
            title: "商铺巡检次数",
            "sub-title-b": "昨日巡检",
            "sub-value": $data.baseData.shopCheckYesterday,
            "yesterday-key": "昨日整改",
            total: $data.baseData.shopCheckTotal,
            yesterday: $data.baseData.shopImproveYesterday
          }, null, 8, ["sub-value", "total", "yesterday"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_DashboardInfoCard, {
            title: "在册商户",
            style: {
              "color": "#1F63FF"
            },
            total: $data.baseData.runningShop,
            yesterday: $data.baseData.runningShopYesterday
          }, null, 8, ["total", "yesterday"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_DashboardInfoCard, {
            style: {
              "color": "#999999"
            },
            title: "注销商户",
            yesterday: 0,
            total: $data.baseData.stopShop
          }, null, 8, ["total"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "dashboardContent"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 10,
      class: "leftEvents"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.indexEvents, e => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: e.id
        }, [e.type == 0 ? (_openBlock(), _createBlock(_component_IndexEmActivity, {
          key: 0,
          data: e
        }, null, 8, ["data"])) : _createCommentVNode("", true), e.type == 1 ? (_openBlock(), _createBlock(_component_IndexInfoActivity, {
          key: 1,
          data: e
        }, null, 8, ["data"])) : _createCommentVNode("", true), e.type == 2 ? (_openBlock(), _createBlock(_component_IndexWarnActivity, {
          key: 2,
          data: e
        }, null, 8, ["data"])) : _createCommentVNode("", true)], 64);
      }), 128))]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 14
    }, {
      default: _withCtx(() => [$data.shopDistribution ? (_openBlock(), _createBlock(_component_VerticalBarChart, {
        key: 0,
        data: $data.shopDistribution
      }, null, 8, ["data"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "dashboardContent"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 18,
      class: "leftEvents"
    }, {
      default: _withCtx(() => [$data.policeEvents ? (_openBlock(), _createBlock(_component_LineChart, {
        key: 0,
        id: "lineChart",
        data: $data.policeEvents
      }, null, 8, ["data"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "rightClocks"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "今日打卡(" + _toDisplayString($data.clocks.length) + ")", 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            class: "more",
            style: {
              "cursor": "pointer"
            },
            onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/clock/list'))
          }, "更多")]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.clocks, r => {
        return _openBlock(), _createBlock(_component_ClockRecord, {
          key: r.id,
          data: r
        }, null, 8, ["data"]);
      }), 128))])]),
      _: 1
    })]),
    _: 1
  })]);
}